export default () => ({
  empty: {
    title: 'Share a screenshot. ',
    subtitle: '(optional)'
  },
  full: {
    title: 'Attached screenshot'
  }
});
